import React from 'react'
import TvNewlySlider from '../../component/TvSwiper/TvNewlySlider'
import TvBaseSlider from '../../component/TvSwiper/TvBaseSlider'
import TvDramaSlider from '../../component/TvSwiper/TvDramaSlider'

function TvShow() {
  return (
    <>

      <div>
        <div className="hero flex flex-col height-full justify-center items-center">
          <div className="hero_center flex flex-col height-full justify-center items-center gap-3 sm:mt-4">
            <h3 className='text-md text-gray-100 font-bold'>Must-See Movies, Now Streaming</h3>
            <p className='text-2xl text-gray-100 flex-wrap '>Watch thousands of shows and movies, with plans starting at $7.99/month.</p>
            <button className={`text-2xl bg-gray-100 text-gray-900 font-bold rounded py-2 px-4 uppercase hover:bg-slate-900 hover:text-gray-300 hover:rounded transition delay-150 duration-300 ease-in-out md:text-xl trial-btn `}>Start your free trial</button>
          </div>
        </div>
        <section className='movie-section m-12'>
          <h1 className='text-4xl text-gray-900 font-bold mx-2'>Tv-Shows</h1>
          <div className="new-movie-section my-12">
            <h3 className='text-gray-900 text-xl uppercase m-2 font-bold'>Newly Added Tv-Shows</h3>
            <TvNewlySlider /></div>
          <div className="new-movie-section my-12">
            <h3 className='text-gray-900 text-xl uppercase m-2 font-bold'>Popular</h3>
            <TvBaseSlider />
          </div>
          <div className="new-movie-section my-12">
            <h3 className='text-gray-900 text-xl uppercase m-2 font-bold'>Drama</h3>
            <TvDramaSlider />
          </div>
        </section>


      </div></>
  )
}

export default TvShow